<template>
  <div class="container" :class="props.isSizePhoneMode || props.isSizeTableMode ? 'card w-auto' : 'w-auto'"
    :style="props.isSizePhoneMode || props.isSizeTableMode ? 'grid-template-rows: min-content min-content auto;' : ''">
    <div v-if="props.isSizeTableMode || props.isSizeTableMode" class="card-header "
      :class="props.isSizePhoneMode || props.isSizeTableMode ? 'p-0 border-bottom' : ''" id="kt_chat_messenger_header"
      :style="props.isSizePhoneMode || props.isSizeTableMode ? 'margin: 7px 30px; 0px;' : ''">
      <div class="card-title ">
        <div class="d-flex justify-content-center me-3 flex-center">
          <button v-if="props.isSizePhoneMode || props.isSizeTableMode" @click="goBack()"
            class="btn btn-icon btn-active-light-primary me-5 w-auto" type="button" :title="$t('back')">
            <img :src="`${base_url}/assets/image/arrow-${locale == 'ar' ? 'right' : 'left'}.svg`" style="width: 15px"
              alt="" />
          </button>
          <span href="#" class="user-name text-hover-primary me-1 lh-1">{{
      $t("Customer data")
    }}</span>
        </div>
      </div>
    </div>
    <div v-if="props.isSizePhoneMode || props.isSizeTableMode"
      class="chat-list-item bg-hover-light-info px-3 border-bottom">
      <div class="separator separator-dashed d-none"></div>

      <div class="d-flex flex-stack py-4">
        <div class="d-flex align-items-center">
          <div class="symbol symbol-50px symbol-circle">
            <img :src="loadFile(images.defaultProfile)"
              :alt="props.conversation ? props.conversation.profile_name : ''" />
          </div>

          <!-- User Details -->
          <div class="ms-5">
            <p class="fs-5 fw-bolder text-gray-900 m-0">
              {{ props.conversation ? props.conversation.profile_name : "" }}
            </p>
            <p class="d-block h-20px overflow-hidden text-black-50 m-0" style="direction: ltr;">
              {{ props.conversation ? formattedPhoneNumber(props.conversation.whatsapp_id) : "" }}
            </p>
          </div>
        </div>
      </div>
      <div class="separator separator-dashed d-none"></div>
    </div>
    <div v-else class="mainInfo">
      <img height="100" width="100" :src="loadFile(images.defaultProfile)"
        :alt="props.conversation ? props.conversation.profile_name : ''" />
      <div class="userName text-truncate">
        {{ props.conversation ? (props.conversation?.contact_display_name ?? props.conversation.profile_name) : "" }}
      </div>
      <div class="phoneNumber">
        {{ props.conversation ? props.conversation.whatsapp_id : "" }}
      </div>
    </div>
    <div class="tabs">
      <ul class="nav nav-tabs nav-line-tabs mb-9 fs-6 custom-tab-list"
        :class="props.isSizePhoneMode ? 'h-100 flex-center' : ''">
        <li class="nav-item">
          <a class="nav-link ripple py-4 active" data-bs-toggle="tab" href="#kt_tab_pane_1">
            {{ $t("Information") }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link ripple py-4" data-bs-toggle="tab" href="#kt_tab_pane_2">
            {{ $t("Orders") }}
          </a>
        </li>
      </ul>
      <div class="tab-content noScrollBar" :class="props.isSizePhoneMode ? 'mt-5' : ''" id="myTabContent">
        <div class="tab-pane infoTab fade show active" id="kt_tab_pane_1" role="tabpanel">
          <div class="info mb-3">
            <div class="title mb-3">{{ $t("Orders Count") }}</div>
            <div class="details mb-3">
              <div v-if="loading.customer" class="skeleton" style="height: 25px; width: 50%;"></div>
              <span v-if="!loading.customer">
                {{ customer.orders_count ? `${customer.orders_count} ${$t("Order")}` : $t('No Orders Yet') }}
              </span>
            </div>
            <div class="title mb-3">{{ $t("Address") }}
              <div class="btn edit-user-infor-button p-0" v-if="customer?.id"
                  @click="editUserInfo(false)" type="button"
                      :conversation="JSON.stringify(conversation)" :id="customer?.id"><i
                  class="bi bi-pencil fs-4 text-dark"></i></div>
            </div>
            <div v-if="loading.customer" class="details mb-3">
              <div class="skeleton" style="height: 25px; width: 50%;"></div>
            </div>
            <div v-else class="details mb-3">
              <div v-show="address" id="profileAddressContainer" class="customerDetails">
                <div class="text-dark">{{ $t("Customer Name") }}</div>
                <div id="receiverName">{{ addressObject?.receiver_name ?? '-' }}</div>
                <div class="text-dark">{{ $t("Customer Number") }}</div>
                <div  id="receiverPhone">{{ addressObject?.phone ?? '-' }}</div>
                <div class="text-dark">{{ $t("City") }}</div>
                <div id="customer-city">{{ addressObject?.city?.name ?? '-' }}</div>
                <div class="text-dark">{{ $t("District") }}</div>
                <div id="customer-district">{{ addressObject?.district ?? '-' }}</div>
                <div class="text-dark">{{ $t("Street Name") }}</div>
                <div id="customer-streetName">{{ addressObject?.street_name ?? '-' }}</div>
                <div class="text-dark">{{ $t("Building Number") }}</div>
                <div id="customer-buildingNumber">{{ addressObject?.building_number ?? '-' }}</div>
                <div class="text-dark">{{ $t("Detailed Address") }}</div>
                <div id="customer-detailedAddress">{{ addressObject?.line_1 ?? '-' }}</div>
              </div>
              <span v-show="!address" id="noProfileAddress">
                {{ $t("Mock Address") }}
              </span>
            </div>
          </div>
        </div>
        <div class="tab-pane ordersTab noScrollBar fade" id="kt_tab_pane_2" role="tabpanel">
          <div v-if="totalOrderCount == 0 && !loading.customer" class="noCustomerOrders">
            <div class="mainText">{{ $t('No Orders') }}</div>
            <div class="description">{{ $t('No Received Orders') }}</div>
            <div class="description">{{ $t('Find New Orders') }}</div>
            <button class="btn ripple bg-transparent border-0 p-0 fw-bold fs-6" @click="addButton">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)"
                  fill="currentColor"></rect>
                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"></rect>
              </svg>
              {{ $t('Add a new order') }}
            </button>
          </div>
          <div v-if="totalOrderCount == 0 && loading.customer" class="noCustomerOrders">
            <div class="mainText">{{ $t('Wait') }}</div>
          </div>
          <div v-if="totalOrderCount > 0" class="filterContainer">
            <div class="titleContainer">
              <div class="title">
                {{ $t("Orders") }} {{ `(${currentTotalOrderCount})` }}
              </div>
              <button class="btn ripple bg-transparent border-0 p-0 fw-bold fs-6" @click="addButton">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)"
                    fill="currentColor"></rect>
                  <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"></rect>
                </svg>
                {{ $t('Add a new order') }}
              </button>
            </div>
            <div class="dropdownContainer">
              <form class="w-100 position-relative mb-6" autocomplete="off">
                <span
                  class="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y">
                  <i class="bi bi-search fs-3"></i>
                </span>
                <input type="text" class="form-control form-control-sm form-control-solid px-15" v-model="textFilter"
                  name="searchOrders" autocomplete="off" :placeholder="$t('Find Orders')" />
              </form>
              <div class="dropdown" aria-labelledby="dropdownMenuButton" @click.stop>
                <button class="btn p-1 ripple imgBtn" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <img :src="loadFile(images.filter)" width="12" height="15" />
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <div class="card-header">{{ $t("Filter Options") }}</div>
                  <div class="card-body">
                    <div class="filterOptionTitle text-dark">
                      {{ $t("status") }}
                    </div>
                    <select v-model="filters.selectedStatus" class="form-select form-select-sm mb-3"
                      aria-label="Default select example">
                      <option :value="'0'">{{ $t(`0`) }}</option>
                      <option v-for=" state  in  orderStatuses " :key="state" :value="state">{{ $t(`order-status-enum.${state}`) }}</option>
                    </select>
                    <div class="filterOptionTitle text-dark">
                      {{ $t("Date") }}
                    </div>
                    <input type="date" v-model="filters.selectedDate" class="form-control form-control-sm" />
                    <div class="actions">
                      <button @click="clearFilters" type="button" class="btn clearButton ripple btn-sm mt-5">
                        <span v-if="!loading.clear">{{ $t("reset") }}</span>
                        <span v-if="loading.clear" class="spinner-border spinner-border-sm" role="status"
                          aria-hidden="true"></span>
                      </button>
                      <button @click="applyFilters" type="button" class="btn submitButton ripple btn-sm mt-5">
                        <span v-if="!loading.filter">{{ $t("filter") }}</span>
                        <span v-if="loading.filter" class="spinner-border spinner-border-sm" role="status"
                          aria-hidden="true"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div ref="scrollContainer"
            v-if="orders.length > 0 && totalOrderCount > 0 && !loading.customer && !loading.orders"
            class="ordersContainer" id="ordersContainer" @scroll="handleScroll">
            <Order v-for="order in orders" :key="order.id" :order="order" :locale="locale" :tenant=tenant @sendInvoice="$emit('sendInvoice', $event)" />
          </div>
          <div class="ordersContainer" v-if="totalOrderCount > 0 && (loading.customer || loading.orders)">
            <div class="orderSkeleton">
              <div class="row align-items-center mb-5">
                <div class="col">
                  <div class="row align-items-start">
                    <div class="col">
                      <div class="skeleton mb-2" style="height: 25px; width: 70%;"></div>
                    </div>
                  </div>
                  <div class="row align-items-start">
                    <div class="col">
                      <div class="skeleton" style="height: 25px; width: 70%;"></div>
                    </div>
                  </div>
                </div>
                <div class="col d-flex justify-content-end">
                  <div class="skeleton" style="height: 25px; width: 70%;"></div>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col">
                  <div class="skeleton" style="height: 50px; width: 50%;"></div>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col">
                  <div class="skeleton" style="height: 25px; width: 100%;"></div>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col">
                  <div class="skeleton" style="height: 25px; width: 100%;"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="orders.length == 0 && totalOrderCount > 0 && !loading.customer && !loading.orders"
            class="noOrders">
            {{ $t('No Orders After Filters') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Order from "@/components/whatsapp-managment/includes/Profile/Order.vue";
import { watch, ref, reactive, onMounted, onUnmounted } from 'vue'
import axios from 'axios'
import parsePhoneNumber from "libphonenumber-js"
import debounce from 'lodash/debounce';
import { PaymentStatuses, InvoiceStatus, MessageTypes, InteractiveSubtypes } from '@/components/whatsapp-managment/interfaces.js'
import { Alert } from '@/v2/plugins/alert';
import { t } from '../../../../locales/index';

const props = defineProps(["conversation", "isSizePhoneMode", "isSizeTableMode", 'locale', 'tenant', "hasNewMsg"]);
const emit = defineEmits(["back"]);

const customer = ref({})
const orders = ref([])
const address = ref('')
const addressObject = ref({})
const base_url = window.location.origin;
const orderStatuses = ref(["New", "Draft", "In_Preparation", "Ready_For_Shipping", "Shipped", "Cancelled", "Delivered"])
const totalOrderCount = ref(0)
const currentTotalOrderCount = ref(0)
const textFilter = ref('')
const loading = ref({
  customer: false,
  orders: false,
  filter: false,
  clear: false
})
const filters = reactive({
  selectedStatus: '0',
  selectedDate: '',
});
let appliedFilters = reactive({
  selectedStatus: '',
  selectedDate: '',
});
let pagination = reactive({
  page: 1,
  per_page: 10,
})

const scrollContainer = ref(null);

const images = {
  defaultProfile: "userImgPlaceholder.png",
  filter: "filter.svg",
};

const loadFile = (fileName) => {
  return window.location.origin + "/assets/image/" + fileName;
};

const formattedPhoneNumber = (phoneNumber) => {
  let rawNumber = phoneNumber
  if (phoneNumber.startsWith('00')) {
    rawNumber = phoneNumber.replace('00', '+');
  }
  try {
    rawNumber = parsePhoneNumber(rawNumber.includes('+') ? rawNumber : `+${rawNumber}`);
    const result = rawNumber.formatInternational();
    return result;
  } catch (error) {
    return rawNumber;
  }
}

const goBack = () => {
  emit("back");
};

const addButton = () => {
    if(customer.value?.id) {
        window.open(`${base_url}/orders/create?customer_id=${customer.value.id}`, '_blank')
    } else {
        Alert.error(t('add-customer-data-first'))
        editUserInfo(true);
    }
}

const fetchCustomerData = async () => {
  // Use try-catch for error handling
  try {
    // Indicate loading state for customer data
    loading.value = { ...loading.value, customer: true };
    const { data } = await axios.get(`${base_url}/api/v1/customers/${props.conversation.whatsapp_id}`);

    const customerData = data?.result?.customer ?? {};
    customer.value = customerData;
    totalOrderCount.value = customerData.orders_count ?? 0;
    currentTotalOrderCount.value = totalOrderCount.value;
    if (Array.isArray(customerData?.customer_addresses)) {
      if(customerData?.customer_addresses.length > 0) {
        addressObject.value = customerData?.customer_addresses[0] ?? {}
        const {building_number, district, street_name} = customerData?.customer_addresses[0] ?? {}
        address.value = `${street_name} - ${district} - ${building_number}`
      }
    }
    await fetchOrders(false);
  } catch (error) {
    resetDataOnError();
  } finally {
    // Reset loading state regardless of outcome
    loading.value.customer = false;
  }
};

// Function to reset data in case of an error
const resetDataOnError = () => {
  customer.value = {};
  orders.value = [];
  currentTotalOrderCount.value = 0;
  address.value = '';
  addressObject.value = {}
  totalOrderCount.value = 0;
  loading.value.orders = false; // Ensure orders loading state is also reset
};

const fetchOrders = async (withPagination) => {
  loading.value.orders = true; // Indicating the start of an order fetch operation
  try {
    const status = appliedFilters.selectedStatus === '0' ? '' : appliedFilters.selectedStatus;
    const filters = `&page=${pagination.page}&per_page=${pagination.per_page}&order_number=${textFilter.value}&sorting_dir=desc&status=${status}&order_date=${appliedFilters.selectedDate}`;
    const response = await axios.get(`${base_url}/api/v1/orders?marketplace=8${filters}&customer_id=${customer.value.id}`);

    orders.value = withPagination ? [...orders.value, ...response.data.result.orders?.data ?? []] : response.data.result.orders?.data ?? [];
    currentTotalOrderCount.value = response.data.result.orders?.total ?? 0;
  } catch (error) {
    orders.value = [];
    currentTotalOrderCount.value = 0;
  } finally {
    loading.value.orders = false;
    loading.value.customer = false;
    loading.value.filter = false;
    loading.value.clear = false;
  }
};

const toggleFilterMenu = () => {
  const dropdownElement = document.getElementById('dropdownMenuButton');
  const dropdownInstance = bootstrap.Dropdown.getInstance(dropdownElement);
  if (dropdownInstance) {
    dropdownInstance.hide();
  }
}

const applyFilters = async () => {
  appliedFilters = filters
  pagination = {
    page: 1,
    per_page: 10
  }
  loading.value.filter = true
  await fetchOrders(false)
  toggleFilterMenu()
};

const clearFilters = async () => {
  pagination.page = 1
  pagination.per_page = 10
  filters.selectedStatus = '0'
  filters.selectedDate = ''
  appliedFilters.selectedStatus = '0'
  appliedFilters.selectedDate = ''
  loading.value.clear = true
  await fetchOrders(false)
  toggleFilterMenu()
};

const handlePagination = () => {
  pagination.page = pagination.page + 1
}

const handleScroll = () => {
  const container = scrollContainer.value;
  if (container) {
    const { scrollTop, scrollHeight, clientHeight } = container;
    if (scrollTop + clientHeight >= scrollHeight) {
      if (!loading.value.orders && (pagination.page * pagination.per_page < currentTotalOrderCount.value))
        handlePagination()
    }
  }
};

const editUserInfo = (redirectToOrders = false)=>{
    console.log("editUserInfo",{
        id: customer.value?.id,
        conversation: props.conversation,
        redirectToOrders
    });
    emit('show-edit',{
        id: customer.value?.id,
        conversation: props.conversation,
        redirectToOrders,
    });
};
const debouncedFetchOrders = debounce(fetchOrders, 500);

watch(() => props.hasNewMsg, async () => {
  if (props.hasNewMsg) {
    if (props.conversation?.last_message?.type == 'order') {
      await fetchCustomerData();
    }
  }
});
watch(() => props.conversation, async () => {
  textFilter.value = ""
  pagination.page = 1
  pagination.per_page = 10
  filters.selectedStatus = '0'
  filters.selectedDate = ''
  appliedFilters.selectedStatus = '0'
  appliedFilters.selectedDate = ''
  totalOrderCount.value = 0
  addressObject.value = {}
  address.value = ''
  await fetchCustomerData();
});

watch(() => props.conversation?.last_message, async (newVal) => {
  if (newVal?.extra_data?.linker_order_status) {
    const ordersCopy = orders.value.map(order => {
      if (order.id == newVal?.extra_data?.linker_order_id) {
        const newOrder = Object.assign(
          order,
          { order_status: newVal?.extra_data?.linker_order_status },
        )
        return newOrder
      } return order
    })
    orders.value = ordersCopy
  }
  if (newVal?.linker_payment_status == PaymentStatuses.success) {
    const ordersCopy = orders.value.map(order => {
      if (order.id == newVal?.extra_data?.linker_order_id) {
        const invoices = (Array.isArray(order.invoices) && order?.invoices?.length > 0) ? order.invoices?.map((invoice, index) => {
          if (index == 0) {
            const newInvoice = Object.assign(invoice, { invoice_status: InvoiceStatus.success })
            return newInvoice
          }
          return invoice
        }) : [{ invoice_status: InvoiceStatus.success, expiry_date: (new Date()).toString() }]
        const newOrder = Object.assign(
          order,
          { invoices }
        )
        return newOrder
      } return order
    })
    orders.value = ordersCopy
  }
  if (newVal?.type == MessageTypes.Interactive) {
    if (newVal?.content?.type == InteractiveSubtypes.nfmReply) {
      const { response_json } = newVal?.content?.nfm_reply
      const parsedJSON = JSON.parse(response_json ?? '{}')
      if (parsedJSON?.flow_token == 'address_flow') {
        const {building_number, district, street_name} = parsedJSON ?? {}
        address.value = `${street_name} - ${district} - ${building_number}`
      }
    }

    if (newVal?.content?.type == InteractiveSubtypes.ButtonReply) {
      if (newVal?.content?.button_reply?.id == "clear_cart") {
        await fetchOrders()
      }
    }
  }
})

watch(() => pagination.page, async () => {
  await fetchOrders(true);
});

watch(() => textFilter.value, () => {
  debouncedFetchOrders(false)
});

onMounted(async () => {
  await fetchCustomerData()
  if (scrollContainer.value) {
    scrollContainer.value.addEventListener('scroll', handleScroll);
  }
})

onUnmounted(() => {
  if (scrollContainer.value) {
    scrollContainer.value.removeEventListener('scroll', handleScroll);
  }
});
</script>

<style scoped lang="scss">
@import "./styles/index.scss";
</style>
